import React, { createContext, useContext, useReducer } from 'react';

const CultureStateContext: React.Context<{
  currentCulture?: 'it'
}> = createContext({});
const CultureDispatchContext = createContext({});

// -- Storage Keys -- //
enum StorageKeys {
  CULTURE = 'titiro_app_culture'
}

// -- Reducers -- //
export enum CultureReducerActions {
  SET_CULTURE
};

function userReducer(state, action: {
  type: CultureReducerActions,
  culture?: string;
}) {
  switch (action.type) {
    case CultureReducerActions.SET_CULTURE:
      return { ...state, culture: action.culture };
    default:
      throw new Error(`Unhandled action provided: ${action.type}`);
  }
}

// -- React Providers -- //
function CultureProvider({ children }) {
  const [state, dispatch] = useReducer(userReducer, {
    currentCulture: sessionStorage.getItem(StorageKeys.CULTURE) ?? 'it'
  });

  return (
    <CultureStateContext.Provider value={state}>
      <CultureDispatchContext.Provider value={dispatch}>
        {children}
      </CultureDispatchContext.Provider>
    </CultureStateContext.Provider>
  );
}

// -- Context Hooks -- //
function useCultureState() {
  const context = useContext(CultureStateContext);
  if (!context) {
    throw new Error('useCultureState can only be used within a CultureProvider');
  }

  return context;
}

function useCultureDispatch() {
  const context = useContext(CultureDispatchContext);
  if (!context) {
    throw new Error('useCultureDispatch can only be used within a CultureProvider');
  }

  return context;
}

// -- Handles -- //
function setCulture(dispatch, language) {
  sessionStorage.setItem(StorageKeys.CULTURE, language);
  dispatch({
    type: CultureReducerActions.SET_CULTURE,
    language
  });
}

export {
  CultureProvider,
  useCultureState,
  useCultureDispatch,
  setCulture
}
